export function isNumber(x: any) {
    // https://stackoverflow.com/questions/33164725/confusion-between-isnan-and-number-isnan-in-javascript
    return !isNaN(Number(x));
}

/** Sums one numeric field over a list, treating null/undefined as 0. */
export function sumBy<T>(
    rows: T[],
    pick: (row: T) => number | null | undefined,
): number {
    return rows.reduce((acc, row) => acc + (pick(row) ?? 0), 0);
}
